import { Database } from '../database/database';
import { database } from '../database/database';
import * as path from 'path';

export class Migrations {
    database: Database = database;
}
